
export const SEO_TITLE_MAX_LENGTH = 120;
export const SEO_DESCRIPTION_MAX_LENGTH = 160;

export const getPageTitle = (pathname) => {
  let title = '';
  switch (pathname) {
    case '/admin':
      title = 'BirthdayAlarm - Admin';
      break;
    case '/dashboard':
      title = 'BirthdayAlarm - Dashboard';
      break;
    case '/change_password':
      title = 'Change Password | BirthdayAlarm';
      break;
    case '/email_settings':
      title = 'Email Settings | BirthdayAlarm';
      break;
    case '/notifications':
      title = 'Notifications | BirthdayAlarm';
      break;
    case '/account':
      title = 'My Account | BirthdayAlarm';
      break;
    case '/payment':
      title = 'Payment Info | BirthdayAlarm';
      break;
    case '/birthday/request':
      title = 'How To Add Reminders | BirthdayAlarm';
      break;
    case '/birthday/request/howto':
      title = 'How To Add Reminders | BirthdayAlarm';
      break;
    case '/address_book':
      title = 'My Contacts | BirthdayAlarm';
      break;
    case '/reminders':
      title = 'My Reminders | BirthdayAlarm';
      break;
    case '/about':
      title = 'Meet The Founders | BirthdayAlarm';
      break;
    case '/team':
      title = 'Meet The Team | BirthdayAlarm';
      break;
    case '/company':
      title = 'Company Information | BirthdayAlarm';
      break;
    case '/terms':
      title = 'Terms of Use | BirthdayAlarm';
      break;
    case '/privacy':
      title = 'Privacy Policy | BirthdayAlarm';
      break;
    case '/contact':
      title = 'Contact Us | BirthdayAlarm';
      break;
    case '/anniversary/gift':
      title = 'Happy Anniversary | BirthdayAlarm';
      break;
    case '/happy_birthday':
      title = 'Happy Birthday | BirthdayAlarm';
      break;
    case '/infographic':
      title = 'Birthday Infographic | BirthdayAlarm';
      break;
    case '/poply':
      title = 'Poply | BirthdayAlarm';
      break;
    case '/name':
      title = 'How Popular is Your Name | BirthdayAlarm';
      break;
    case '/reminders/holiday/add':
      title = 'Add Holidays | BirthdayAlarm';
      break;
    case '/group-cards':
      title = 'Group Cards | BirthdayAlarm';
      break;
    case '/login':
      title = 'Login | BirthdayAlarm';
      break;
    case '/register':
      title = 'Register | BirthdayAlarm';
      break;
    case '/reminders/birthday/add':
    case '/reminders/birthday/more':
    case '/reminders/birthday/add/manual':
      title = 'My Reminders | BirthdayAlarm';
      break;
    case '/mycards/upcoming':
    case '/mycards/sent':
    case '/mycards/received':
    case '/mycards/drafts':
    case '/mycards/favorites':
      title = 'My Cards | BirthdayAlarm';
      break;
    default:
      if (pathname.indexOf('/cards/birthday') >= 0 || pathname.indexOf('/birthday/suggestions') >= 0 || pathname.indexOf('/birthday/browse') >= 0) {
        title = 'Birthday Cards | BirthdayAlarm';
      } else if (pathname.indexOf('/cards/anniversary') >= 0 || pathname.indexOf('/anniversary/suggestions') >= 0 || pathname.indexOf('/anniversary/browse') >= 0) {
        title = 'Anniversary Cards | BirthdayAlarm';
      } else if (pathname.indexOf('/cards/holiday') >= 0 || pathname.indexOf('/holiday/suggestions') >= 0 || pathname.indexOf('/holiday/browse') >= 0) {
        title = 'Holiday Cards | BirthdayAlarm';
      } else if (pathname.indexOf('/name/') >= 0) {
        const name = pathname.replace('/name/', '');
        title = `How Popular is the name ${name} | BirthdayAlarm`;
      } else {
        title = 'BirthdayAlarm ⏰ - 4500+ Online Greeting Cards - send ecards by text or email';
      }
  }
  return title;
}

const removeWordsToFit = (text, maxLength) => {
  if (text.length > maxLength) {
    const lastSpace = text.lastIndexOf(' ', maxLength);
    let result = text.substring(0, lastSpace);
    const remainingWords = text.substring(lastSpace + 1).split(' ');
    let remainingLength = maxLength - result.length;
    // add words till we pass the length
    for (let i = 0; remainingLength - remainingWords[i].length > 0 && i < remainingWords.length; i += 1) {
      result += ` ${remainingWords[i]}`;
      remainingLength -= remainingWords[i].length;
    }
    return result;
  }
  return text;
}

const decodeHtmlEntity = (str) => {
  return str.replace(/&#(\d+);/g, function (match, dec) {
    return String.fromCharCode(dec);
  });
};

export const updatePageTitle = (pathname) => {
  if (document) {
    let title = getPageTitle(pathname);
    if (title && title.length > SEO_TITLE_MAX_LENGTH) {
      title = removeWordsToFit(title, SEO_TITLE_MAX_LENGTH);
    }
    title = decodeHtmlEntity(title);
    document.title = title;
    if (document.head) {
      const twitterTitle = document.head.querySelector('meta[name="twitter:title"]');
      if (twitterTitle) {
        twitterTitle.content = title;
      }
      const ogTitle = document.head.querySelector('meta[property="og:title"]');
      if (ogTitle) {
        ogTitle.content = title;
      }
    }
  }
}

export const updatePageOgURL = (pathname) => {
  if (document && document.head) {
    const ogURL = document.head.querySelector('meta[property="og:url"]');
    if (ogURL) {
      ogURL.content = `https://${BDAY_ENV !== 'prod' ? `${BDAY_ENV}.` : ''}birthdayalarm.com${pathname}`;
    }
    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.href = `https://${BDAY_ENV !== 'prod' ? `${BDAY_ENV}.` : ''}birthdayalarm.com${pathname}`;
    }
  }
}